// @flow
import type {
  Crop,
} from 'fc-model-crops/types'

// Libs
import React, { Component } from 'react'
import _find from 'lodash/find'
import _size from 'lodash/size'
import _map from 'lodash/map'
import _isEmpty from 'lodash/isEmpty'
import { Link } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'

// container
import RecommendedRatesContainer from '../../containers/RecommendedRates'

import {
  // utils
  convertCommentsToFrontendUnits,
  // messages
  messages,
} from 'hfty-comments'

// utils
import {
  getCropUnit,
} from 'hfty-utils'

// Component
import Header from './Header'
import Button from '@react-mdc/button'

// Constants
import {
  PROP_CROP,
} from 'hfty-model-comments'

import {
  PROP_CROP_ID,
} from 'fc-model-crops'

// Styles
import { primary, white, grey, lightGrey } from 'hfty-styles/src/colors'

const styles = {
  container: {
    position: 'relative',
    flex: '1 1 auto',
    display: 'flex',
    overflow: 'auto',
    backgroundColor: 'white',
    flexDirection: 'column',
  },
  contentContainer: {
    overflow: 'auto',
  },
  content: {
    maxWidth: 900,
    margin: '0 auto',
    padding: 20,
    overflowX: 'hidden',
    lineHeight: 1.6,
  },
  textDiv: {
    marginLeft: 5,
    marginTop: 20,
  },
  nutrientHeader: {
    backgroundColor: primary(),
    padding: 10,
    fontWeight: 500,
    color: white(),
    borderLeft: `10px solid ${grey()}`,
  },
  paragraph: {
    marginBottom: 15,
  },
  paragraphBold: {
    marginBottom: 15,
    fontWeight: 500,
  },
  sectionBody: {
    margin: '10px 20px 20px 20px',
  },
  navigation: {
    padding: 10,
    backgroundColor: lightGrey(0.8),
    alignItems: 'center',
    boxShadow: 'rgba(0, 0, 0, 0.2) 0px 2px 2px',
  },
  loading: {
    color: grey(0.9),
    margin: 40,
    textAlign: 'center',
  },
}

type Props = {
  comment: Object,
  crops: Array<Crop>,
  currentUserUnits: string,
  match: Object,
  actions: {
    fetchComments: Function,
  }
}

class RecommendedRates extends Component {
  props: Props

  componentDidMount () {
    this.props.actions.fetchComments()
  }

  render (): React.Element<any> {
    const { comment, crops, currentUserUnits } = this.props
    const crop: ?Crop = _find(crops, (crop: Crop): boolean => (
      crop[PROP_CROP_ID] === comment[PROP_CROP])
    )
    const cropUnit = getCropUnit(crop, currentUserUnits)
    const convertedComment = convertCommentsToFrontendUnits(comment, crops, currentUserUnits)
    const jobId = Number(this.props.match.params.jobId)
    return (
      <div style={styles.container}>
        <div style={styles.navigation}>
          <Link to={`/comments/${jobId}`}>
            <Button
              raised
              dense
              primary
            >
              <FormattedMessage {...messages['back']} />
            </Button>
          </Link>
        </div>
        <div style={styles.contentContainer}>
          {_size(convertedComment) === 0
            ? <div style={styles.loading}>
              <FormattedMessage {...messages['loading']} />...
            </div>
            : <div style={styles.content}>
              <Header
                data={convertedComment.data}
                cropUnit={cropUnit}
              />
              <div style={styles.textDiv}>
                <p>
                  <FormattedMessage {...messages['recommendedRatesWarning']} />
                </p>
              </div>
              <div style={styles.textDiv}>
                {_map(convertedComment.data.comments, (nutrient: Array, key: string): React.Element<any> => {
                  return (
                    <div>
                      <div style={styles.nutrientHeader}>{key}</div>
                      <div style={styles.sectionBody}>
                        {_map(nutrient, (subArr: Array): React.Element<any> => {
                          if (subArr.length === 1) {
                            return <div style={styles.paragraphBold}>{subArr[0]}</div>
                          } else if (subArr.length === 2) {
                            if (!_isEmpty(subArr[0])) {
                              return (
                                <div>
                                  <div style={styles.paragraphBold}>{subArr[0]}</div>
                                  <div style={styles.paragraph}>{subArr[1]}</div>
                                </div>
                              )
                            }
                            return (
                              <div style={styles.paragraph}>
                                {subArr[1]}
                              </div>)
                          }
                        })}
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>
          }
        </div>
      </div>
    )
  }
}

export default RecommendedRatesContainer(RecommendedRates)
